var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188.341,
    height: 188.341,
    viewBox: "0 0 188.341 188.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angry",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_453",
    "data-name": "Grupo 453",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_448",
    "data-name": "Grupo 448",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_447",
    "data-name": "Grupo 447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2692_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2693_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2694_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2695_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2696_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2697_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2698_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2699_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2723_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2739_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2740_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2741_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2742_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2743_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2744_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_161",
    "data-name": "Elipse 161",
    cx: 94.17,
    cy: 94.17,
    r: 94.17,
    fill: "#fd6643"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_450",
    "data-name": "Grupo 450",
    transform: "translate(55.177 105.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_603",
    "data-name": "Caminho 603",
    d: "M259.486,316.994H241.167a20.675,20.675,0,1,0-41.35,0H181.5a38.994,38.994,0,1,1,77.988,0Z",
    transform: "translate(-181.498 -278)",
    fill: "#634c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_451",
    "data-name": "Grupo 451",
    transform: "translate(37.19 49.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_604",
    "data-name": "Caminho 604",
    d: "M188.179,191.5a20.876,20.876,0,1,1-34.694-20.375Z",
    transform: "translate(-147.131 -171.128)",
    fill: "#634c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_605",
    "data-name": "Caminho 605",
    d: "M327.488,186.125A20.877,20.877,0,0,1,286.44,191.5l34.694-20.375a20.816,20.816,0,0,1,6.355,15Z",
    transform: "translate(-213.527 -171.128)",
    fill: "#634c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_452",
    "data-name": "Grupo 452",
    transform: "translate(94.171 105.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_606",
    "data-name": "Caminho 606",
    d: "M294.993,316.993H276.674A20.7,20.7,0,0,0,256,296.319V278A39.037,39.037,0,0,1,294.993,316.993Z",
    transform: "translate(-256 -278)",
    fill: "#634c4c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/angry.67bb3321b267ea051f671774ccfb30be.svg";
export { ForwardRef as ReactComponent };